import React from 'react';

import { StandardOrgSettingInput } from '../../../../shared-components/StandardSettingInput';

import styles from '../../OrganizationSettings.module.css';
import AuthSubstitutionsTable from './AuthSubstitutionsTable';
import AuthSubstituionsForm from './AuthSubstitutionsForm';
import LoginWorkflowComponent from './LoginWorkflowComponent';

export const LdapsComponent = () => {
  return (
    <div>
      <LoginWorkflowComponent />
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>Add Prefix</div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authPrefix" type="input" />
        </div>
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>Add Suffix </div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authSuffix" type="input" />
        </div>
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>Allow Login with Username</div>
        <StandardOrgSettingInput
          settingName="authUsernameLogin"
          type="radio"
          options={[
            { label: 'True', value: true },
            { label: 'False', value: false },
          ]}
        />
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>Force 3rd Party Certificate Verification</div>
        <StandardOrgSettingInput
          settingName="authCertVerify"
          type="radio"
          options={[
            { label: 'True', value: true },
            { label: 'False', value: false },
          ]}
        />
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>LDAP Auth Host</div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authLdapHost" type="input" />
        </div>
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>LDAP Auth Port</div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authLdapPort" type="input" />
        </div>
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>LDAP Auth Encryption </div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authLdapEncryption" type="input" />
        </div>
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>LDAP Base</div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authLdapBase" type="input" />
        </div>
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>LDAP search first</div>
        <StandardOrgSettingInput
          settingName="authLdapSearchFirst"
          type="radio"
          options={[
            { label: 'True', value: true },
            { label: 'False', value: false },
          ]}
        />
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>LDAP Search DN</div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authLdapSearchDn" type="input" />
        </div>
      </div>
      <div className={styles.flexListStyleWithPadding}>
        <div className={styles.mainLabelStyle}>LDAP Search Password</div>
        <div className={styles.inputBoxStyle}>
          <StandardOrgSettingInput settingName="authLdapSearchPass" type="input" />
        </div>
      </div>
      <AuthSubstituionsForm />
      <AuthSubstitutionsTable />
    </div>
  );
};
